module.exports = __webpack_public_path__ + "media/custom/images/img34-a4669480214b0cd381e1b2e1aafd9c47.jpg";